import { DeleteIcon } from '@icons';
import clsx from 'clsx';
import { Loader } from 'components/UI/Loader';
import { ButtonHTMLAttributes } from 'react';

type Props = {
	text: string;
	Icon?: React.ReactNode;
	variant?: 'primary' | 'secondary' | 'destructive';
	loading?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = ({
	text,
	Icon,
	loading,
	disabled,
	className,
	variant = 'primary',
	...props
}: Props) => {
	return (
		<button
			className={clsx(
				'text-sm font-semibold min-w-56 min-h-16 px-6 flex items-center justify-center transition-colors',
				disabled && 'opacity-50',
				// Primary variant
				{
					'bg-primary-500 text-white rounded-md': variant === 'primary',
					'hover:bg-primary-700': variant === 'primary' && !loading
				},
				// Secondary variant
				{
					'text-gray-800 rounded-md': variant === 'secondary',
					'hover:bg-gray-800/10': variant === 'secondary' && !loading
				},
				// Destructive variant
				{
					'bg-error-500/25 text-error-700 rounded-md': variant === 'destructive',
					'hover:bg-error-700/50': variant === 'destructive' && !loading
				},
				className
			)}
			disabled={loading || disabled}
			{...props}
		>
			{variant === 'destructive' && <DeleteIcon className="text-icon-300 mr-2" />}
			{loading ? (
				<Loader
					color={c => {
						if (variant === 'destructive') {
							return c.error;
						}

						return c.white;
					}}
				/>
			) : (
				<>
					{Icon && <span className="flex items-center mr-2">{Icon}</span>}
					{text}
				</>
			)}
		</button>
	);
};
